import type { MapboxIMap } from '..';

export function getScreenshot(this: MapboxIMap) {
  const png = this._native.getCanvas().toDataURL('image/png');
  return png;
}
